import React from "react";

// components
import { Row, Col, Button } from "reactstrap";

export default function Acoes(props) {
    const {
        showLoading,
        showPlay,
        handleBackward,
        handlePauseMap,
        handlePlayMap,
        handleForward,
        toggleModalSetup
    } = props;

    return (
        <>
            <Row>
                <Col md="12" xs="12">
                    {!showLoading &&
                        <Row>
                            <Col md="9" xs="9">
                                {showPlay && <Button onClick={handleBackward} color="secondary" size="sm" type="button"><i className="fas fa-backward"></i></Button>}
                                {showPlay &&
                                    <Button onClick={handlePlayMap} color="secondary" size="sm" type="button"><i className="fas fa-play"></i></Button>
                                }
                                {!showPlay &&
                                    <Button onClick={handlePauseMap} color="secondary" size="sm" type="button"><i className="fas fa-pause"></i></Button>
                                }
                                {showPlay && <Button onClick={handleForward} color="secondary" size="sm" type="button"><i className="fas fa-forward"></i></Button>}
                            </Col>
                            <Col md="2" xs="3" className="text-left">
                                <Button onClick={toggleModalSetup} color="info" size="sm" type="button"><i className="fas fa-filter"></i></Button>
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
        </>
    )
}